import styled from "styled-components";
import { ASSETS } from "../../utils/config";
import { Switch } from "@mui/material";

const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);

export const ModalContainer = styled.div`
  min-width: 600px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 40vw;
  height: 60vh;
  box-shadow: 24px 24px 48px rgba(0, 0, 0, 0.2);
  padding: 20px;
  border-radius: 14px;
  background-image: url(${ASSETS.bg});
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  position: relative; /* Relative position to use as a reference for children */

  /* Adjust the height based on the screen height */
  // @media (max-height: 750px) {
  //   height: 55vh;
  // }
`;

export const ModalContent = styled.div`
  padding-top: 48px;
  padding-bottom: 48px;
`;

export const ButtonContainer = styled.div`
  position: absolute;
  bottom: 15px;
  right: 20px; /* Distance from the right */
  display: flex;
  gap: 15px; /* Space between buttons */
  align-items: center;
`;

export const PaginationContainer = styled.div`
  position: absolute;
  bottom: 35px; /* Distance from the bottom */
  left: 20px; /* Distance from the left */
  display: flex;
  align-items: center;
`;

export const PaginationDot = styled.div`
  width: ${(props) =>
    props.current ? "12px" : "8px"}; /* Bigger for the active page dot */
  height: ${(props) => (props.current ? "12px" : "8px")};
  margin: 0 5px;
  border-radius: 50%;
  background-color: ${(props) =>
    props.active ? "rgba(143, 56, 239, 1)" : "#CBB4FE"};
  transition: all 0.3s ease-in-out; /* Smooth size/color transitions */
`;

export const TopCircle = styled.div`
  width: 150px; /* Adjust size */
  height: 150px; /* Adjust size */
  background-image: url(${ASSETS.Wheely});
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  border-radius: 50%; /* Make it a circle */
  position: absolute;
  top: 0;
  left: 50%;
  transform: translate(-50%, -50%); /* Center horizontally and vertically */
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1); /* Optional shadow for effect */
  z-index: 10; /* Ensure it appears above modal content */
`;
export const Container = styled.div`
  display: flex;
  position: relative;
  flex-direction: column;
  padding: 10px;
  margin-top: 20px;
  gap: 10px; /* Add vertical space between direct children */
`;

export const Input = styled.input`
  width: 100%;
  padding: 8px;
  font-size: 14px;
  border: 1px solid #ccc;
  border-radius: 4px;
  outline: none;
  margin-top: 5px;
  margin-bottom: 15px;
  &:focus {
    border-color: #007bff;
  }
`;

export const DefaultSwitch = styled(Switch)`
  & .MuiSwitch-switchBase.Mui-checked {
    color: rgba(143, 56, 239, 1); /* Fixed color value */

    &:hover {
      background-color: rgba(143, 56, 239, 1) 99; /* Fixed color value with opacity */
    }
  }

  & .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track {
    background-color: rgba(143, 56, 239, 1); /* Fixed color value */
  }
`;

export const SkipButton = styled.div`
  text-decoration: underline;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  color: #007bff;
  white-space: nowrap;
`;
